import { makeAutoObservable } from 'mobx';
interface Modal {
  open: boolean;
  body: JSX.Element | null;
  smallBody: JSX.Element | null;
  close: boolean;
  deleteModalOpen: boolean;
  smallOpen: boolean;
}

export default class ModalStore {
  modal: Modal = {
    open: false,
    body: null,
    smallBody: null,
    close: true,
    deleteModalOpen: true,
    smallOpen: false,
  };

  constructor() {
    makeAutoObservable(this);
  }

  openSidebar = (content: JSX.Element) => {
    this.modal.open = true;
    this.modal.body = content;
  };

  openModal = (content: JSX.Element) => {
    this.modal.open = true;
    this.modal.body = content;
  };

  closeModal = () => {
    this.modal.open = false;
    this.modal.body = null;
  };

  openDeleteModal = () => {
    this.modal.deleteModalOpen = true;
  };

  closeDeleteModal = () => {
    this.modal.deleteModalOpen = false;
  };
  openSmallModal = (content: JSX.Element) => {
    this.modal.smallOpen = true;
    this.modal.smallBody = content;
  };

  closeSmallModal = () => {
    this.modal.smallOpen = false;
  };
}
